import { CheckoutDataObject } from '@shared/analytics/models/checkout/checkout.models';

export const CHECKOUT: CheckoutDataObject = {
    ecommerce: {
        currencyCode: undefined,
        checkout: {
            actionField: {
                step: undefined,
            },
            products: [],
        },
    },
};
